<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Roles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-toolbar-items>
                  <v-btn dark text v-on="on">
                    Nuevo
                  </v-btn>
                </v-toolbar-items>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.name" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" dark @click.native="editRole(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" dark @click.native="addRole(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="listRoles"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
                >
                  mdi-check-bold
              </v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
                >
                  mdi-minus
              </v-icon>
            </template>
            <template v-slot:item.permissions="{ item }">
              <v-chip class="ma-1" small v-for="item in item.permissions" style="min-width: 88px;">
                {{ item.descripcion }}
              </v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
              v-if="permisosList.findIndex(i => i.name === 'edit_roles') > -1"
              color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon
              v-if="!item.deleted_at && permisosList.findIndex(i => i.name === 'delete_roles') > -1" color="red"  @click="deleteRole(item)">mdi-close</v-icon>
              <!--<v-icon dark>mdi-folder-settings-variant</v-icon>-->
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="listRoles.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      changePassword:false,
      mask: '##########',
      celular: '',
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
        { text: 'Nombre', value: 'name', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action', width: '15%' }
      ],
      distritosList:[],
      editedIndex: -1,
      activo: true,
      editedItem: {
        name:'',
      },
      defaultItem: {
        name:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Role' : 'Editar Role'
    },
    ...mapGetters([
      "permisosList",
      "listRoles"
    ]),
  },
  mounted() {
    this.getRoles();
  },
  // watch: {
  //   dialog (val) {
  //     val || this.close()
  //   }
  // },
  methods: {
    getRoles() {
      this.loading = true;
      this.$store.dispatch("GET_ROLES",  { url: "/roles" } ).then(response => {
        this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    editItem (item) {
      this.editedIndex = this.listRoles.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },
    addRole(){
      if (this.$refs.form.validate()) {
        var data = this.editedItem;
        this.$store.dispatch("SAVE_ROLES",  { url: "/role", data: data } ).then(response => {
          this.close ();
          Swal.fire({
            icon: 'success',
            title: 'Rol guardado correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getRoles();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    editRole(item){
      item.activo = this.activo
      if (this.$refs.form.validate()) {
        this.$store.dispatch("EDIT_ROLE",  { url: "/role/" + item.id, data: item } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Rol actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getRoles();
        })
        .catch(err => {
          console.log(err);
        });
        this.close()
      }
    },
    deleteRole(item){
      this.$swal({
        title: '¿Desea eliminar Rol "' + item.name + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_ROLE",  { url: "/role/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Rol eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getRoles();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
